// extracted by mini-css-extract-plugin
export var button = "styles-module--button--ZIY+F";
export var svgIcon = "styles-module--svgIcon--wvqKC";